import axios from 'axios'
import { toaster } from 'uikit'

export const axiosInstance = axios.create()

const TIMEOUT = 60 * 3000
axiosInstance.defaults.timeout = TIMEOUT

const onRequestSuccess = (config: any) => {
  return config
}

const onRequestError = (err: any) => {
  return Promise.reject(err)
}

const onResponseSuccess = (response: any) => {
  return response
}

const onResponseError = (err: any) => {
  const status = err?.status || err?.response?.status
  const statusText = err.response?.statusText

  if (status === 401 || statusText === 'Unauthorized') {
    toaster.create({
      title: 'Запрос не авторизован',
      description: `Сообщение: ${err.message} Код ошибки: ${status}`,
      variant: 'solid',
      type: 'warning',
      closable: true,
    })

    // window.location.href = '/'
  }

  return Promise.reject(err)
}

axiosInstance.interceptors.request.use(onRequestSuccess, onRequestError)
axiosInstance.interceptors.response.use(onResponseSuccess, onResponseError)
